<script setup>
import { ref } from 'vue'

const form = ref(null)
const isSending = ref(false)
const message = ref('')
const selectedTemplate = ref('contact_form') // Default template_id

const sendEmail = async () => {
  if (!form.value) return

  isSending.value = true
  message.value = ''

  const formData = new FormData(form.value)
  const formObject = Object.fromEntries(formData.entries()) // Convert FormData to JSON

  try {
    const data = await $fetch('/api/send-emailjs', {
      method: 'POST',
      body: {
        template_id: selectedTemplate.value, // Send selected template
        form_data: formObject // Send form data only, no keys
      }
    })

    if (data.success) {
      message.value = 'Email sent successfully!'
      form.value.reset()
    } else {
      throw new Error(data.message || 'Unknown error')
    }
  } catch (error) {
    message.value = `Failed: ${error.message}`
  } finally {
    isSending.value = false
  }
}
</script>

<template>
  <form
    ref="form"
    @submit.prevent="sendEmail"
    class="flex flex-col w-1/3 mx-auto mt-8 border-2 border-[maroon] rounded-md shadow-md p-4"
  >
    <label>Name</label>
    <input
      type="text"
      name="user_name"
    />
    <label>Email</label>
    <input
      type="email"
      name="user_email"
    />
    <label>Message</label>
    <textarea name="message"></textarea>
    <button
      type="submit"
      class="bg-[blue] text-white hover:bg-[red] border-2 border-[blue] rounded-md px-2 w-fit mx-auto"
    >
      Send
    </button>
    <p v-if="message">{{ message }}</p>
  </form>
</template>

<style scoped>
input,
textarea {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 0.5rem;
  margin-bottom: 1rem;
  background-color: #f9f9f9;
}
</style>
